var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Multiselect',{attrs:{"options":_vm.option_list,"hide-selected":true,"taggable":true,"internal-search":false,"searchable":true,"multiple":true,"placeholder":""},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }